// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LeftSquareTwoToneSvg from "@ant-design/icons-svg/es/asn/LeftSquareTwoTone";
import AntdIcon from '../components/AntdIcon';

var LeftSquareTwoTone = function LeftSquareTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: LeftSquareTwoToneSvg
  }));
};

LeftSquareTwoTone.displayName = 'LeftSquareTwoTone';
export default React.forwardRef(LeftSquareTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/LeftSquareTwoTone.js
// module id = 1407
// module chunks = 0